import SRConst from "@/helpers/Constants/SignalRConstants.js";

export default {
  name: 'SchedulerSignalRMixin',

  data() {
    return {
    };
  },

  mounted() {
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.AppointmentChange,
      this.handleSignalRAppointmentEvent
    ]);
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.JobChange,
      this.handleSignalRJobEvent
    ]);
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.AppointmentChange,
      this.handleSignalRAppointmentEvent
    ]);
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.JobChange,
      this.handleSignalRJobEvent
    ]);
  },

  methods: {
    async handleSignalRAppointmentEvent(data) {
      //console.log('Signal R appointmentchanged event', data);
      const id = data.appointmentId;
      var type = data.changeType;
      //Event for new or updated appointment
      if (type == SRConst.AppointmentChangeTypes.New || type == SRConst.AppointmentChangeTypes.Change) {
        await this.addOrUpdateEventInStoreById(id);
      }
      //Event for deleted appointment
      else if (type == SRConst.AppointmentChangeTypes.Delete) {
        this.removeEventInStoreById(id);
      }
    },

    async handleSignalRJobEvent(data) {
      var start = this.startDate;
      var end = this.endDate;
      var appList = this.scheduler._eventStore.getEvents({
        includeOccurrences: false,
        startDate: start,
        endDate: end,
        filter: (e) => (e.jobId == data.jobId),
      });

      var addOrUpdate = (id) => this.addOrUpdateEventInStoreById(id);
      appList.forEach(app => addOrUpdate(app.id));
    },
  },

  computed: {},

  watch: {},
}